<template>
  <v-alert :width="1000000" v-model="active" :type="type" class="alertUp">
    {{ msg }}
  </v-alert>
</template>

<script>
const props = {
  active: {
    default: false,
    type: Boolean,
  },
  type: {
    default: "error",
    type: String,
  },
  msg: {
    default: "",
    type: String,
  },
};

export default {
  data: () => ({}),
  methods: {},
  props: props,
};
</script>

<style scoped>
.alertUp {
  float: none;
  position: absolute;
  z-index: 2;
}
</style>
